var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "c-reservation-form" },
    [
      _c("div", { staticClass: "c-reservation-form__title" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$t("BranchReservation.Form.title")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      !_vm.isLogged
        ? _c("div", { staticClass: "c-reservation-form__sub-title" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("BranchReservation.Form.subTitle1")) +
                "\n        "
            ),
            _c(
              "a",
              {
                staticClass: "c-link",
                attrs: { title: "Prihlásenie" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.openLoginModal()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("BranchReservation.Form.logIn")))]
            ),
            _vm._v(" "),
            _c("strong", [
              _vm._v(_vm._s(_vm.$t("BranchReservation.Form.subTitle2"))),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("FormItem", {
        attrs: {
          name: "email",
          type: "email",
          value: _vm.getFieldValue("email"),
          label: _vm.$t("BranchReservation.Form.Email.label"),
          isRequired: true,
        },
      }),
      _vm._v(" "),
      _c("FormItem", {
        attrs: {
          name: "phone",
          type: "tel",
          value: _vm.getFieldValue("phone"),
          label: _vm.$t("BranchReservation.Form.Phone.label"),
          isRequired: true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "c-form__item c-form__item--checkbox" }, [
        _c("input", {
          attrs: { type: "hidden", name: "is_company", value: "0" },
        }),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.isCompany,
              expression: "isCompany",
            },
          ],
          staticClass: "c-form__input",
          attrs: {
            type: "checkbox",
            name: "is_company",
            value: "1",
            "data-custom": "custom",
            placeholder: _vm.$t("BranchReservation.Form.IsCompany.label"),
            id: "customer-custom-send-b2b-request",
          },
          domProps: {
            checked: Array.isArray(_vm.isCompany)
              ? _vm._i(_vm.isCompany, "1") > -1
              : _vm.isCompany,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.isCompany,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = "1",
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isCompany = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isCompany = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isCompany = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "c-form__label",
            attrs: { for: "customer-custom-send-b2b-request" },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("BranchReservation.Form.IsCompany.label")) +
                "\n        "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isCompany,
              expression: "isCompany",
            },
          ],
        },
        [
          _c("FormItem", {
            attrs: {
              name: "company",
              value: _vm.getFieldValue("company"),
              label: _vm.$t("BranchReservation.Form.Company.label"),
              isRequired: _vm.isCompany,
              "data-autocomplete-name": "company",
            },
          }),
          _vm._v(" "),
          _c("FormItem", {
            attrs: {
              name: "org_num",
              value: _vm.getFieldValue("org_num"),
              label: _vm.$t("BranchReservation.Form.OrgNum.label"),
              isRequired: _vm.isCompany,
              "data-autocomplete-name": "org_num",
            },
          }),
          _vm._v(" "),
          _c("FormItem", {
            attrs: {
              name: "tax_num",
              value: _vm.getFieldValue("tax_num"),
              label: _vm.$t("BranchReservation.Form.TaxNum.label"),
              "data-autocomplete-name": "tax_num",
            },
          }),
          _vm._v(" "),
          _c("FormItem", {
            attrs: {
              name: "vat_num",
              value: _vm.getFieldValue("vat_num"),
              label: _vm.$t("BranchReservation.Form.VatNum.label"),
              "data-autocomplete-name": "vat_num",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }